module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Italic.50f23476.woff";